export default __webpack_public_path__ + "static/media/cancel.754c265c.svg";